import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/tabs/Tabs';
import BreadcrumbPageHeader from '@/layouts/BreadcrumbPageHeader';
import { Container } from '@/layouts/main/Main';
import { PageTitle } from '@/utils/Title';
import { FC, Suspense } from 'react';
import { PageLoading } from '@/layouts/PageLoading';
import RuleManager from './RuleManager';
import TemplateManager from './TemplateManager';

const NotificationSettings: FC = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: 'Admin',
      to: ''
    },
    {
      name: 'Notification Settings',
      to: '/admin/notifications'
    }
  ];

  return (
    <>
      <PageTitle>Notification Settings</PageTitle>
      <BreadcrumbPageHeader breadcrumbs={breadcrumbs}>
        <div className="flex justify-between gap-5 items-center font-bold">
          <h3 className="text-3xl">Notification Settings</h3>
        </div>
      </BreadcrumbPageHeader>
      
      <div className="flex-1 overflow-y-auto">
        <Container animate="pop" className="w-full py-8">
          <Tabs defaultValue="rules" className="w-full">
            <TabsList className="mb-4">
              <TabsTrigger value="rules">Routing Rules</TabsTrigger>
              <TabsTrigger value="templates">Email Templates</TabsTrigger>
            </TabsList>

            <TabsContent value="rules" className="mt-4">
              <Suspense fallback={<PageLoading />}>
                <RuleManager />
              </Suspense>
            </TabsContent>

            <TabsContent value="templates" className="mt-4">
              <Suspense fallback={<PageLoading />}>
                <TemplateManager />
              </Suspense>
            </TabsContent>
          </Tabs>
        </Container>
      </div>
    </>
  );
};

export default NotificationSettings;
